import { Component } from "react";
import { compose } from "redux";

import _ from "underscore";

import Link from "admin/shared/ui/Link.Component";
import { reportsConnector } from "../../../services/reports/connector";
import ApiButton from "../../../shared/ui/Api.Button";
import { borrowerWithdrawalConnector } from "../../../services/orders/userProfile/borrowerWithdrawalConnector";

class BorrowerDepotSurplus extends Component {
  componentDidMount() {
    this.props.getBorrowerDepots();
  }
  constructor(props) {
    super(props);
  }

  generateWithdrawalOrders = (listOfDepots) => {
    let listOfGuids = listOfDepots.map((item) => item.AccountId);
    this.props.createBorrowerSurplusWithdrawal(listOfGuids);
  };

  render() {
    let listToRender = _.filter(
      this.props.reports.borrowerDepots.data,
      (item) => {
        return item.Balance.Amount >= 1;
      },
    );

    listToRender = _.sortBy(listToRender, (item) => {
      return item.Balance.Amount;
    }).reverse();

    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <h3>Borrower Surplus</h3>
            <ApiButton
              sending={this.props.create.fetching}
              sent={this.props.create.fetched}
              buttonLabel={"Generate Withdrawal Orders"}
              onButtonClick={() => this.generateWithdrawalOrders(listToRender)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-12">
              <div className="col-md-6">Account ID</div>
              <div className="col-md-6">Balance</div>
            </div>
            {this.props.reports.borrowerDepots.fetching ? (
              <div className="col-md-12">Loading data...</div>
            ) : (
              <div>
                {listToRender.map((item, index) => {
                  return (
                    <div className="col-md-12" key={index}>
                      <div className="col-md-6">
                        <Link
                          toState={"userOverview"}
                          parameters={["accountId", item.AccountId]}
                        >
                          {item.AccountId}
                        </Link>
                      </div>
                      <div className="col-md-6">
                        {Math.round(item.Balance.Amount * 100) / 100} kr
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default compose(
  reportsConnector,
  borrowerWithdrawalConnector,
)(BorrowerDepotSurplus);
